import styled from "styled-components";
import FixaButton from "@coworker/apprestructured/src/shared/wrappers/FixaButton/FixaButton";

interface LocalCombinationInfoBoxProps {
  title: string;
  description: string;
  buttonText: string;
  onButtonClick: () => void;
}

const Container = styled("div")`
  font-size: 14px;
  background: var(--white);
  max-width: 100vw;
  padding: 17px 21px;
`;
const Inner = styled("div")`
  padding: 20px;
  background: var(--grey100);
  border-radius: 5px;
`;

const Title = styled("h3")``;

const Description = styled("div")`
  margin-top: 10px;
  margin-bottom: 20px;
`;

export const LocalCombinationInfoBox = ({
  title,
  description,
  buttonText,
  onButtonClick,
}: LocalCombinationInfoBoxProps) => {
  return (
    <Container>
      <Inner>
        <Title>{title}</Title>
        <Description>{description}</Description>
        <FixaButton
          size="medium"
          type="primary"
          onClick={onButtonClick}
          fluid={true}
          className="lc-info-box-button"
        >
          {buttonText}
        </FixaButton>
      </Inner>
    </Container>
  );
};
